import { readAsText } from 'promise-file-reader'

import { ConnectwareError, ConnectwareErrorType } from '../../domain'

export const readFileAsText = (file: File): Promise<string> =>
    readAsText(file).catch((e: Error) => Promise.reject(new ConnectwareError(ConnectwareErrorType.UNEXPECTED, e.message)))
